import * as React from "react";
import { Control, Errors } from "react-redux-form";
import * as DTOS from "../../../../FeralScan.dtos";
import { required } from "../../../Common/validators";
import * as DashboardActionCreators from "../../../../actions/dashboard.actions";
import FormItem from "../FormItem";
import RadioButton from "./RadioButton";
import { showErrors } from "./ReactReduxFormSettings";
import ValidationMessage from "./ValidationMessage";
import { controlColumnClass } from "../consts";


export type RadioButtonControlProps = {
    radioButtonClassName?: string;
    name: string;
    description: string;
    attachment: any;
    mandatory: boolean;
    mapMarkerComponent: any;
    model: string;
    options: DTOS.QuestionOption[];
    readOnly?: boolean;
    value: string;
};

export type RadioButtonControlActions = {
    error: typeof DashboardActionCreators.errorRequest;
};

export type RadioButtonControlPropsAndActions = RadioButtonControlProps & RadioButtonControlActions;

class RadioButtonControl extends React.PureComponent<RadioButtonControlPropsAndActions, any> {
    render() {
        return ([
            <div
                className={controlColumnClass}
                data-toggle="buttons"
                key={`${this.props.model}.div`}
            >
                {this.props.options
                    ? this.props.options.map((option, optionIndex) => {
                        return (
                            <div className={this.props.radioButtonClassName} key={`${this.props.model}.options.${optionIndex}.div`}>
                                <Control.radio
                                    component={RadioButton}
                                    controlProps={{
                                        blockButton: true,
                                        checked: undefined,
                                        disabled: false,
                                        divClassName: "custom-control custom-radio",
                                        id: `${this.props.model}.options.${optionIndex}`,
                                        inputClassName: "custom-control-input",
                                        label: option.label,
                                        labelClassName: "custom-control-label",
                                        largeButton: false,
                                        name: undefined,
                                        readOnly: false,
                                        value: undefined,
                                        onBlur: undefined,
                                        onChange: undefined,
                                        onFocus: undefined
                                    }}
                                    disabled={this.props.readOnly}
                                    key={`${this.props.model}.options.${optionIndex}`}
                                    model={`${this.props.model}.value`}
                                    validators={{
                                        required: this.props.mandatory ? required : () => true
                                    }}
                                    value={option.value}
                                />
                                {option.questions ?
                                    option.questions.map((q, questionIndex) => {
                                        return (
                                            this.props.value == option.value ?
                                                <FormItem
                                                    formItemType={q.questionTypeCode}
                                                    formTemplateItemId={q.questionId}
                                                    key={`${this.props.model}.options.${optionIndex}.questions.${questionIndex}`}
                                                    mandatory={this.props.value == option.value}
                                                    mapMarkerComponent={this.props.mapMarkerComponent}
                                                    model={`${this.props.model}.options.${optionIndex}.questions.${questionIndex}`}
                                                    name={q.questionDescription}
                                                    value={option.value}
                                                    error={this.props.error}
                                                    hideRow={true}
                                                /> : undefined
                                        );
                                    }) :
                                    undefined
                                }
                            </div>
                        );
                    })
                    : undefined}
                    
                <Errors
                    className="invalid-feedback d-block"
                    component={ValidationMessage}
                    key={`${this.props.model}.Errors`}
                    messages={{
                        required: "Please select an option"
                    }}
                    model={`${this.props.model}.value`}
                    show={showErrors}
                />
            </div>,
        ]);
    }
}

export default RadioButtonControl;
